import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesConditionsDataGrid } from "src/components/views/erp/sales/masterData/salesConditions/SalesConditionsDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesConditions")({
	staticData: { title: i18n.t("sales_conditions"), legacyViewKey: "salesConditionPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesConditionsDataGrid />;
}
